import { createStore } from 'vuex'
import useAuthStore from '@/stores/authStore'


export const store = createStore({
    state() {
        return {
            documents: [],
            closed_documents: [],

            // user_token: {},
            user: {},
            user_authenticated_recently: false,
            pre_login_user_tokens: null,
            public_token: null,
            payment: {},
            media: {},
            actions_render_key: 0,
            remove_document_ids: [],
            respite: {
                error: '',
                params: {},
                document: {},
            },
            amortization: {
                error: '',
                params: {},
                document: {},
                multiple: {
                    documents: [],
                    selected: [],
                },
            },
            tickets: [],
            unread_tickets: 0,
            unhandled_overpayments: 0,
            direct_debit_payments: {},
            profile_dialog: null,
            message_dialog: null,
        }
    },
    getters: {
        // ADA-4410: token truth lives in the Pinia authStore. These getters are
        // thin read-only proxies so legacy code (api_mixin, views) keeps working
        // unchanged until it is migrated. Writes go through user_mixin → authStore.
        token: () => {
            return useAuthStore().selectedToken?.token ?? null
        },
        selected_token: () => {
            const idx = useAuthStore().tokensList.findIndex((t) => t.selected)
            return idx === -1 ? undefined : String(idx)
        },
        token_json: () => {
            // selectedToken.payload is jwtDecode(token) — same shape parse_token() gave
            return useAuthStore().selectedToken?.payload ?? {}
        },
    },
    mutations: {
        mutate(state, payload) {
            state[payload.property] = payload.data
        },
        mutate_key(state, payload) {
            state[payload.property][payload.key] = payload.data
        },
    },
    actions: {
        set_state_property({ commit }, payload) {
            return commit('mutate', {
                property: payload.property,
                data: payload.data,
            })
        },
        update_key_in_state_property({ commit }, payload) {
            return commit('mutate_key', {
                property: payload.property,
                data: payload.data,
                key: payload.key,
            })
        },
    },
})
